export const InitializationState = {
    NotStarted: 'NotStarted',
    Initializing: 'Initializing',
    Success: 'Success',
    Failed: 'Failed',
};
